// Credentials that ride in a URL, kept out of analytics. No imports, so it
// runs under plain node:test.

// The one-time connector link's token: in the page's fragment
// (/connect/connector#<token>), in its path on older links, and in the API
// path the page calls (/api/connector-link/<token>). The fragment may follow a
// trailing slash or a query string.
const CONNECTOR_LINK = /(\/connect\/connector(?:\/?(?:\?[^#\s"']*)?#|\/)|\/api\/connector-link\/)[^/?#\s"'&]+/g;

export function redactUrl(text: string): string {
  return text.replace(CONNECTOR_LINK, "$1[redacted]");
}

// Every string in an event's property bag, at any depth (exception lists,
// nested objects), redacted in place. A frozen object is left as it is.
export function redactProperties<T>(value: T, depth = 0): T {
  if (!value || typeof value !== "object" || depth > 20) return value;
  const bag = value as Record<string, unknown>;
  for (const key of Object.keys(bag)) {
    const v = bag[key];
    if (typeof v === "string") {
      try {
        bag[key] = redactUrl(v);
      } catch {
        // Read-only property.
      }
    } else if (v && typeof v === "object") redactProperties(v, depth + 1);
  }
  return value;
}
